import * as React from 'react';
import cn from 'classnames';
import { ExareStatus, MoneyFragment } from '@websky/graphql';

import { useTheme } from '../../../theme';
import Notification, { Props as NotificationProps } from '../../../BaseComponents/Notification';
import { useExareInfoStatus } from './useExareInfoStatus';

export interface Props {
	show: boolean;
	status: ExareStatus;

	refundPrice?: MoneyFragment;
	className?: string;
	passengersNames?: string;
	timelimit?: string;
	splittedOrderId?: string;
	onGoToTicket?: React.DispatchWithoutAction;
}

const OrderRefundStatus: React.FC<Props> = props => {
	const { OrderRefundStatus: css } = useTheme('Refund');
	const { title, actionText, status, onActionClick, text } = useExareInfoStatus(
		'refund',
		props.status,
		props.onGoToTicket,
		props.passengersNames,
		props.splittedOrderId,
		props.refundPrice
	);

	if (!props.show) {
		return null;
	}

	return (
		<Notification
			className={cn(css.status, props.className)}
			type="global"
			status={status as NotificationProps['status']}
			title={title}
			onClickAction={onActionClick}
			actionText={actionText}
			text={text}
		/>
	);
};

export default OrderRefundStatus;
